import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import Colors from '../../../../../styles/colors';

const InfoGridItem = ({
    icon, iconAltText, title, text,
}) => (
    <Grid item mobile={12} tablet={4}>
        <img src={icon} alt={iconAltText} height="127" width="120" />
        <Typography variant="h3" mt={2}>
            {title}
        </Typography>
        <Typography
            variant="body1"
            mt={2}
            sx={{
                fontSize: '1.6rem',
                lineHeight: '25px',
                color: Colors.darkGray,
            }}
        >
            {text}
        </Typography>
    </Grid>
);

InfoGridItem.propTypes = ({
    icon: PropTypes.string,
    iconAltText: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
});

InfoGridItem.defaultProps = ({
    icon: null,
    iconAltText: '',
    title: '',
    text: '',
});

export default InfoGridItem;
